import vueDropzone from 'vue2-dropzone';
import { isObject } from 'lodash';

export default {
  components: {
    vueDropzone,
  },
  data() {
    return {
      loading: false,
      displayedError: false,
      dropOptions: {
        url: () => this.fileUrl,
        dictRemoveFile: '❌',
        dictDefaultMessage: 'Drop files here to upload, or click to <span class="underline">select</span> a file to upload.',
        addRemoveLinks: true,
        autoProcessQueue: false,
        uploadMultiple: true,
        parallelUploads: 10,
        thumbnailWidth: 125,
        thumbnailHeight: 125,
        acceptedFiles: '.csv,.xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png,.eml,.ppt,.pptx,.pptm,.pps,.ppsx',
        maxFilesize: 50, // MB
        dictFileTooBig: 'File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.',
        headers: {
          Authorization: `Bearer ${this.$store.getters.authToken}`,
        },
        renameFile(file) {
          const fileParts = file.name.split('.');
          const extension = fileParts[fileParts.length -1].toLowerCase();
          fileParts[fileParts.length -1] = extension;
          return fileParts.join('.');
        },
      },
    };
  },
  props: {
    fileUrl: {
      default: null,
    },
  },
  methods: {
    processFiles() {
      this.displayedError = false;
      this.loading = true;
      this.$refs.dropzone.processQueue();
    },
    onQueueComplete() {
      this.onAllFilesUploaded();
      this.complete();
    },
    // Override point that runs whenever the queue completes, including after
    // refused files and failed requests.
    onAllFilesUploaded() {
    },
    validate() {
    },
    onFileSuccess(file, response) {
    },
    onFileError(file, errorMessage) {
      const text = this.formatErrorMessage(errorMessage);
      // Dropzone reports a failed request once per file for every file in it.
      const repeatedRequestError = Boolean(file.xhr) && this.displayedError;

      this.$refs.dropzone.removeFile(file);

      if (file.xhr) {
        this.displayedError = true;
      }

      if (!repeatedRequestError) {
        this.$notify({
          title: 'Error',
          text,
          type: 'error',
        });
      }
      this.complete();
    },
    complete() {
      this.loading = false;
    },
    attachParams(file, xhr, formData) {
    },
    getFiles() {
      return this.$refs.dropzone.getQueuedFiles();
    },
    hasFiles() {
      return this.getFiles().length > 0;
    },
    formatErrorMessage(errorMessage) {
      const defaultMessage = 'Something went wrong. Please try again later.';

      if (!errorMessage) {
        return defaultMessage;
      }

      if (isObject(errorMessage)) {
        const { error } = errorMessage;
        if (!error) {
          return defaultMessage;
        }

        const { errors } = error;

        if (!errors || errors.length === 0) {
          return defaultMessage;
        }

        return Object.values(errors).join('\n');
      }

      return errorMessage;
    },
    checkForDuplicates(file) {
      const existingFiles = this.$refs.dropzone.getAcceptedFiles();
      const duplicate = existingFiles.find(f =>
        f !== file &&
          f.name === file.name &&
          f.size === file.size &&
          f.type === file.type);

      if (duplicate) {
        this.$refs.dropzone.removeFile(file);
        this.$notify({
          title: 'Duplicate file',
          text: `Duplicate images detected, duplicates will be removed.`,
          type: 'warn',
        });
      }
    },
  },
};
